import React from "react";
import { Form } from "react-bootstrap";
import { FieldProps } from "formik";

import FormikFieldCustomProps from "./helpers/FormikFieldCustomProps";

const YesNo: React.FC<FormikFieldCustomProps & FieldProps & { className?: string; onChange?: (val: any) => void; }> = ({
  field: { name, value, onChange },
  form: { setFieldValue, errors, touched },
  ...props
}) => (
  <Form.Group className={props.className}>
    {/* <pre>{JSON.stringify(props, null, 2)}</pre> */}
    <Form.Check
      type="checkbox"
      id={props.id}
      checked={value !== false}
      disabled={props.disabled || false}
      onChange={(e: any) => {
        setFieldValue(name, e.target.checked ? true : false);
        onChange(e.target.checked);
        if(props.onChange) {
          props.onChange(e.target.checked)
        }
      }}
      label={props.label}
      isInvalid={Boolean(touched[name] && errors[name])}
    />
    <Form.Control.Feedback type="invalid">
      {errors[name]}
    </Form.Control.Feedback>
  </Form.Group>
);

export default YesNo;
